var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "tabContainer" } },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticClass: "app-main-inner section",
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px"
            }
          }
        },
        [
          _c(
            "template",
            { slot: "up" },
            [
              _c("div", { staticClass: "section operations" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cooperateEdit,
                        expression: "cooperateEdit"
                      }
                    ],
                    staticClass: "triggers"
                  },
                  [
                    _vm.enableUiCustom
                      ? _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: { margin: "7px 10px 7px 0px" }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEdit,
                            expression: "isEdit"
                          }
                        ]
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "1",
                              type: "primary",
                              disabled: _vm.selectedContainerUsage === null
                            },
                            on: { click: _vm.changeSealHandler }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.SealNoChangeAdfterInspection"
                                  )
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "2",
                              type: "primary",
                              disabled: _vm.isAutoLoad
                            },
                            on: { click: _vm.autoLoadHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AutoAllocation")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.autoLoadContractHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.AutoAllocationContract"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "3",
                              type: "primary",
                              disabled: _vm.selectedContainerUsage === null
                            },
                            on: { click: _vm.autoUnloadHandler }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("SeaExport.CleanOutTheLoadingRecord")
                                ) +
                                " "
                            )
                          ]
                        ),
                        !_vm.job.lclMasterUuid
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "4",
                                  type: "danger",
                                  disabled: _vm.selectedContainerUsage === null
                                },
                                on: { click: _vm.deleteContainerHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.DeleteTheLoadingRecord")
                                  ) + " "
                                )
                              ]
                            )
                          : _vm._e(),
                        !_vm.job.lclMasterUuid
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "ncmNo",
                                  type: "primary",
                                  disabled: _vm.selectedContainerUsage === null
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editNcmNoHandler(true)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_Edit") + "NCM No."
                                  ) + " "
                                )
                              ]
                            )
                          : _vm._e(),
                        !_vm.job.lclMasterUuid
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "4",
                                  type: "primary",
                                  disabled: _vm.selectedContainerUsage === null
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editNcmNoHandler(false)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_Edit") +
                                      _vm.$t(
                                        "CargoMsg.Cargo_WoodenPackagingType"
                                      )
                                  ) + " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.isFCL
                          ? _c(
                              "el-button",
                              {
                                attrs: { no: "5", type: "primary" },
                                on: { click: _vm.downTemplateBtn_clickHandler }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("SeaExport.TemplateDownload")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-upload",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "padding-left": "5px"
                            },
                            attrs: {
                              action: "string",
                              "http-request": _vm.importExcelEventHandler,
                              "show-file-list": false,
                              accept: ".xls, .xlsx",
                              "before-upload": _vm.beforeUploadUsage,
                              no: "6"
                            }
                          },
                          [
                            _vm.isFCL
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isEdit,
                                        expression: "isEdit"
                                      }
                                    ],
                                    attrs: { type: "primary", no: "7" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.ExcelImport"))
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm.job.uuid
                          ? _c(
                              "el-badge",
                              {
                                staticClass: "item",
                                attrs: { "is-dot": _vm.harbourCheckRead }
                              },
                              [
                                _vm.job.uuid
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "share-button",
                                        attrs: { no: "8", type: "primary" },
                                        on: { click: _vm.harbourCompare }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SeaExport.UpdatePortAreaData"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.job.uuid
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "copyDoorPoint",
                                  type: "primary",
                                  size: "mini"
                                },
                                on: { click: _vm.copyDoorPointData }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyDoorPoint"))
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    !_vm.isEdit && _vm.isHZ
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-menu",
                              {
                                staticClass:
                                  "el-menu-button el-button el-button--primary el-button--mini",
                                staticStyle: {
                                  width: "90px",
                                  "vertical-align": "top"
                                },
                                attrs: {
                                  "text-color": "#404144",
                                  "active-text-color": "#404144",
                                  mode: "horizontal"
                                },
                                on: { select: _vm.toEDIContainers }
                              },
                              [
                                _c(
                                  "el-submenu",
                                  { attrs: { index: "index" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "el-menu-btn-text",
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.EDIContainers")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-submenu",
                                      { attrs: { index: "original" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("SeaExport.Original"))
                                          )
                                        ]),
                                        _c(
                                          "el-menu-item",
                                          { attrs: { index: "API0" } },
                                          [_vm._v("API")]
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", [
                      _c(
                        "span",
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("SeaExport.CargoQuantityDescription")
                              ) +
                              "：" +
                              _vm._s(_vm.lbTotalDesc.lblContainerDesc) +
                              " " +
                              _vm._s(
                                _vm.$t("SeaExport.TotalNumberOfPackages")
                              ) +
                              "：" +
                              _vm._s(_vm.lbTotalDesc.lbTotalQuantity) +
                              " " +
                              _vm._s(_vm.$t("SeaExport.TotalWeight")) +
                              "：" +
                              _vm._s(_vm.lbTotalDesc.lbTotalWeight) +
                              " " +
                              _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                              "：" +
                              _vm._s(_vm.lbTotalDesc.lbTotalCubage) +
                              " "
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.btnshowAWindow && !_vm.isEdit,
                                  expression: "btnshowAWindow && !isEdit"
                                }
                              ],
                              staticClass: "can-operate",
                              attrs: { type: "primary", no: "9" },
                              on: { click: _vm.showAWindowClickHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.ViewAssociatedBusiness")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm.openXhqCustomsAll && !_vm.job.lclMasterUuid
                      ? _c(
                          "div",
                          { staticStyle: { float: "right" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.xhqShowSendContainerHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.SendContainer")))]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jingyuWarehouse && !_vm.job.lclMasterUuid
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "200px" },
                                attrs: { no: "ReleaseJY", type: "primary" },
                                on: { click: _vm.toReleaseJY }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.ReleaseJY")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "TakeContainerJY",
                                  type: "primary"
                                },
                                on: { click: _vm.toTakeContainerJY }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.TakeContainerJY"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "ContainerPreloadJY",
                                  type: "primary"
                                },
                                on: { click: _vm.toContainerPreloadJY }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ContainerPreloadJY"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  "config-module": "130115",
                  "grid-options": _vm.gridOptions,
                  "grid-params": _vm.gridParams,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.containerUsages,
                  "wrap-text": true
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "template",
            { slot: "down" },
            [
              _c("portData-goods-info", {
                ref: "portDataGoodsInfo",
                attrs: {
                  job: _vm.job,
                  "is-editing": _vm.isEditGoods && _vm.isEdit,
                  "is-or-not-display-so-no": true,
                  "is-add-spelling": _vm.job.spelling,
                  "del-po-items-uuids": _vm.delPoItemsUuids,
                  "slave-customs-declaration-enable":
                    _vm.slaveCustomsDeclarationEnable,
                  "is-uppercase-by-config": _vm.isUppercaseByConfig,
                  title: _vm.enableUiCustom
                    ? _vm.$t("SeaExport.BoxContents")
                    : "",
                  "element-dict": _vm.enableUiCustom
                    ? _vm.goodsElementDict
                    : null
                },
                on: { change: _vm.handleChange }
              }),
              _vm.jingyuWarehouse
                ? _c("div", { staticStyle: { width: "80px" } }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jingyuWarehouse && !_vm.isEdit,
                            expression: "jingyuWarehouse && !isEdit"
                          }
                        ],
                        staticStyle: {
                          "flex-direction": "row-reverse",
                          display: "flex",
                          "justify-content": "center",
                          "align-items": "center",
                          color: "deepskyblue"
                        },
                        on: { click: _vm.showLclDynamicList }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("SeaExport.LclDynamic")) + " "
                        ),
                        _c("i", {
                          class: _vm.jyLclDynamicDialog.visible
                            ? "el-icon-caret-bottom"
                            : "el-icon-caret-top"
                        })
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        2
      ),
      _c("seal-number-change-dialog", {
        attrs: {
          visible: _vm.boxNoDialog.visible,
          "prop-form-data": _vm.selectedContainerUsage
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.boxNoDialog, "visible", $event)
          },
          sealCloseHandler: _vm.sealCloseHandler
        }
      }),
      _c("associated-business-dialog", {
        attrs: {
          visible: _vm.associatedBusinessDialog.visible,
          "a-data": _vm.associatedBusinessDialog.aData,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.associatedBusinessDialog, "visible", $event)
          },
          refresh: _vm.refresh
        }
      }),
      _c("new-compare-harbour-dialog", {
        attrs: {
          visible: _vm.harbourDialog,
          "data-source": _vm.poItems,
          "harbour-source": _vm.sourceList,
          job: _vm.job,
          "hc-flag": _vm.hcFlag,
          "hq-flag": _vm.hqFlag,
          "container-height-flag": _vm.containerHeightFlag,
          "h-q-h-c-flag": _vm.HQHCFlag
        },
        on: {
          "update:visible": function($event) {
            _vm.harbourDialog = $event
          },
          addContainer: _vm.handleAddContainer
        }
      }),
      _c("tab-container-record-link-dialog", {
        attrs: {
          visible: _vm.containerRecordDialog.visible,
          "job-uuid": _vm.job.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.containerRecordDialog, "visible", $event)
          },
          selectTruckingRecordHandler: _vm.selectTruckingRecordHandler
        }
      }),
      _c("box-Information-Verification", {
        attrs: {
          "dialog-visible": _vm.dialogVisible,
          "content-show": _vm.contentShow,
          container: _vm.container,
          "job-uuid": _vm.job.uuid
        },
        on: {
          "update:dialogVisible": function($event) {
            _vm.dialogVisible = $event
          },
          "update:dialog-visible": function($event) {
            _vm.dialogVisible = $event
          }
        }
      }),
      _vm.openXhqCustomsAll
        ? _c("xhq-send-container-dialog", {
            attrs: {
              "dialog-visible": _vm.xhqSendContainerDialog.visible,
              job: _vm.job,
              "container-usage": _vm.xhqSendContainerDialog.containerUsage,
              "selected-container": _vm.xhqSendContainerDialog.container
            },
            on: {
              "update:dialogVisible": function($event) {
                return _vm.$set(_vm.xhqSendContainerDialog, "visible", $event)
              },
              "update:dialog-visible": function($event) {
                return _vm.$set(_vm.xhqSendContainerDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("ncn-edit-dialog", {
        attrs: {
          job: _vm.job,
          containers: _vm.ncnEditDialog.containers,
          title: _vm.ncnEditDialog.title,
          "is-ncm-no": _vm.ncnEditDialog.isNcmNo,
          visible: _vm.ncnEditDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.ncnEditDialog, "visible", $event)
          },
          ncnEditChange: _vm.ncnEditChange
        }
      }),
      _c("jy-release-dialog", {
        attrs: {
          job: _vm.job,
          containers: _vm.jyReleaseDialog.containers,
          visible: _vm.jyReleaseDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyReleaseDialog, "visible", $event)
          }
        }
      }),
      _c("jy-take-container-dialog", {
        attrs: {
          job: _vm.job,
          containers: _vm.jyTakeContainerDialog.containers,
          visible: _vm.jyTakeContainerDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyTakeContainerDialog, "visible", $event)
          }
        }
      }),
      _c("jy-container-preload-dialog", {
        attrs: {
          job: _vm.job,
          containers: _vm.jyContainerPreloadDialog.containers,
          visible: _vm.jyContainerPreloadDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyContainerPreloadDialog, "visible", $event)
          }
        }
      }),
      _c("jy-lcl-dynamic-dialog", {
        attrs: {
          "job-uuid": _vm.job.uuid,
          visible: _vm.jyLclDynamicDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyLclDynamicDialog, "visible", $event)
          }
        }
      }),
      _c("api-popup", {
        attrs: {
          visible: _vm.apiPopup.visible,
          title: _vm.apiPopup.title,
          "interface-type": _vm.apiPopup.interfaceType,
          "interface-array": _vm.apiPopup.interfaceArray,
          "is-hz": _vm.isHZ
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.apiPopup, "visible", $event)
          },
          selectedApi: _vm.selectedApiCallback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }